import { useQuery } from "@tanstack/react-query";
import { apiCall } from "@/lib/api";
import type { ProximosVencerResponse, RecaudacionResponse } from "./schemas";

export function useRecaudacion(desde?: string, hasta?: string) {
  return useQuery({
    queryKey: ["cobranza", "recaudacion", desde, hasta],
    queryFn: () => {
      const params: Record<string, string> = {};
      if (desde) params.desde = desde;
      if (hasta) params.hasta = hasta;
      return apiCall<RecaudacionResponse>("get", "/api/v1/cobranza/recaudacion", { searchParams: params });
    },
    refetchInterval: 60_000, // refresh cada minuto
  });
}

/** rc90 — Ciclos por revisar: contratos reactivados por pago tras suspensión
 * larga sin decisión humana sobre el corte (típicamente Toku/portal). */
export type CicloRevisionItem = {
  contrato_id: string;
  contrato_codigo: string;
  cliente_id: string;
  cliente_codigo: string;
  cliente_nombre: string;
  estatus: string;
  fecha_corte_actual: number;
  fecha_pago: string;
  dia_sugerido: number;
  ultima_mensualidad_vencimiento: string | null;
};

export type CiclosRevisionResponse = {
  items: CicloRevisionItem[];
  total: number;
};

export function useCiclosRevision() {
  return useQuery({
    queryKey: ["cobranza", "ciclos-revision"],
    queryFn: () =>
      apiCall<CiclosRevisionResponse>("get", "/api/v1/cobranza/ciclos-revision"),
    refetchInterval: 60_000,
  });
}

export function useProximosVencer(dias?: number) {
  return useQuery({
    queryKey: ["cobranza", "proximos", dias],
    queryFn: () => {
      const params: Record<string, string | number> = {};
      if (dias) params.dias = dias;
      return apiCall<ProximosVencerResponse>("get", "/api/v1/cobranza/proximos-vencer", { searchParams: params });
    },
    refetchInterval: 60_000,
  });
}
